export function useTeamSizes () {
    const teamSizes = [
        '1–5',      // startup or individual team
        '6-15',     // early-stage startup
        '16-30',    // scaling team
        '31-75',    // mature team
        '76-150',   // Dunbar’s number threshold (hard to maintain all internal connections)
        '151-500',  // mature business
        '500+'      // structured company with departments
    ]   

    return teamSizes;
}